
const PO_BOX_ADDRESS_RE = /(?:P(?:ost(?:al)?)?[\.\-\s]*(?:(?:O(?:ffice)?[\.\-\s]*)?B(?:ox|in|\b|\d)|o(?:ffice|\b)(?:[-\s]*\d)|code)|box[-\s\b]*\d)/i
export function isPOBoxAddress(address: string): boolean {
    return PO_BOX_ADDRESS_RE.test(address)
}
